import { NavLink } from 'react-router-dom'
import styled, { css } from 'styled-components'

import { mediaQueries } from '@fourthwall/components'

const ItemStyles = css`
  display: block;

  border-radius: var(--radius-brand);
  padding: var(--space-200) var(--space-400);

  font-size: var(--font-size-400);
  font-weight: var(--font-weight-regular);
  line-height: var(--font-line-height-400);
  letter-spacing: var(--font-letter-spacing-normal);

  width: 100%;

  color: var(--text-secondary);

  transition: all var(--motion-duration-100) var(--motion-ease-in-out);

  @media (hover: hover) and (pointer: fine) {
    &:hover {
      background-color: var(--bg-secondary);
    }

    &:active {
      background-color: var(--bg-secondary-hover);
    }
  }

  ${mediaQueries.laptop} {
    width: 216px;
  }
`

export const Container = styled.li`
  list-style: none;
`

export const Wrapper = styled.div`
  position: relative;

  display: flex;

  gap: var(--space-400);
  align-items: center;

  cursor: pointer;
`

export const Link = styled(NavLink)<{ $active: boolean }>`
  ${ItemStyles}

  ${({ $active }) =>
    !$active &&
    css`
      &:hover {
        color: var(--text-primary);
      }
    `};

  ${({ $active }) =>
    $active &&
    css`
      background-color: var(--bg-secondary);
      color: var(--text-primary);
      font-weight: var(--font-weight-medium);
    `};
`

export const Label = styled.div`
  position: relative;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0; // This is required for "ellipsis" to work properly in a "flex" element
`

export const TagWrapper = styled.div`
  margin-left: calc(-1 * var(--space-200));
  cursor: pointer;
`

export const ChildrenContainer = styled.div`
  padding-top: var(--space-50);

  > * {
    margin-bottom: var(--space-100);

    &:last-child {
      margin-bottom: 0;
    }
  }
`

export const Spacer = styled.div`
  width: 16px;
`
